import { makeStyles } from "@fluentui/react-components";
import designTokens from "../../theme/customTheme";

export const useHelpStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    rowGap: designTokens.spacing[3],
    columnGap: designTokens.spacing[3],
    paddingTop: designTokens.spacing[6],
    paddingBottom: designTokens.spacing[6],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    maxWidth: "1200px",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    "@media (min-width: 768px)": {
      paddingTop: designTokens.spacing[12],
      paddingBottom: designTokens.spacing[12],
      paddingLeft: designTokens.spacing[8],
      paddingRight: designTokens.spacing[8],
    },
    "@media (min-width: 1024px)": {
      paddingTop: designTokens.spacing[16],
      paddingBottom: designTokens.spacing[16],
      paddingLeft: designTokens.spacing[16],
      paddingRight: designTokens.spacing[16],
    },
    "@media (min-width: 1440px)": {
      paddingLeft: designTokens.spacing[32],
      paddingRight: designTokens.spacing[32],
    },
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    rowGap: designTokens.spacing[3],
    columnGap: designTokens.spacing[3],
    marginBottom: designTokens.spacing[4],
    "@media (min-width: 768px)": {
      rowGap: designTokens.spacing[4],
      columnGap: designTokens.spacing[4],
      marginBottom: designTokens.spacing[6],
    },
  },
  backButton: {
    fontWeight: designTokens.fontWeight.normal,
    borderRadius: designTokens.borderRadius.lg,
    paddingLeft: designTokens.spacing[3],
    paddingRight: designTokens.spacing[4],
    minHeight: designTokens.controlHeight.md,
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      borderTopColor: designTokens.neutral[400],
      borderRightColor: designTokens.neutral[400],
      borderBottomColor: designTokens.neutral[400],
      borderLeftColor: designTokens.neutral[400],
    },
  },
  title: {
    fontSize: designTokens.fontSize.xl,
    fontWeight: designTokens.fontWeight.semibold,
    margin: "0",
    color: designTokens.neutral[900],
    "@media (min-width: 768px)": {
      fontSize: designTokens.fontSize["2xl"],
    },
  },
  welcomeCard: {
    backgroundColor: designTokens.neutral.white,
    paddingTop: designTokens.spacing[5],
    paddingBottom: designTokens.spacing[5],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    borderRadius: designTokens.borderRadius.lg,
    borderTopWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: designTokens.neutral[200],
    borderRightColor: designTokens.neutral[200],
    borderBottomColor: designTokens.neutral[200],
    borderLeftColor: designTokens.neutral[200],
    boxShadow: designTokens.shadow.sm,
    fontSize: designTokens.fontSize.base,
    lineHeight: "1.6",
    color: designTokens.neutral[700],
    marginBottom: designTokens.spacing[4],
    marginTop: designTokens.spacing[4],
    boxSizing: "border-box",
    "@media (min-width: 768px)": {
      paddingTop: designTokens.spacing[6],
      paddingBottom: designTokens.spacing[6],
      paddingLeft: designTokens.spacing[6],
      paddingRight: designTokens.spacing[6],
    },
  },
  accordionContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0",
    columnGap: "0",
    width: "100%",
    maxWidth: "100%",
    "> :first-child": {
      borderTopLeftRadius: designTokens.borderRadius.lg,
      borderTopRightRadius: designTokens.borderRadius.lg,
    },
    "> :last-child": {
      borderBottomLeftRadius: designTokens.borderRadius.lg,
      borderBottomRightRadius: designTokens.borderRadius.lg,
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: designTokens.neutral[200],
    },
  },
  accordionItem: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: "0",
    borderTopWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "0",
    borderLeftWidth: "1px",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: designTokens.neutral[200],
    borderRightColor: designTokens.neutral[200],
    borderBottomColor: designTokens.neutral[200],
    borderLeftColor: designTokens.neutral[200],
    boxShadow: designTokens.shadow.sm,
    width: "100%",
    maxWidth: "100%",
    overflowX: "hidden",
    boxSizing: "border-box",
  },
  accordionHeader: {
    width: "100%",
    maxWidth: "100%",
    "> button": {
      justifyContent: "space-between",
      fontWeight: designTokens.fontWeight.semibold,
      paddingTop: designTokens.spacing[4],
      paddingBottom: designTokens.spacing[4],
      paddingLeft: designTokens.spacing[5],
      paddingRight: designTokens.spacing[5],
      fontSize: designTokens.fontSize.base,
      width: "100%",
      maxWidth: "100%",
      whiteSpace: "normal",
      wordWrap: "break-word",
    },
  },
  contactCard: {
    backgroundColor: designTokens.accent[50],
    paddingTop: designTokens.spacing[5],
    paddingBottom: designTokens.spacing[5],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    borderRadius: designTokens.borderRadius.lg,
    borderTopWidth: "1px",
    borderRightWidth: "1px",
    borderBottomWidth: "1px",
    borderLeftWidth: "1px",
    borderTopStyle: "solid",
    borderRightStyle: "solid",
    borderBottomStyle: "solid",
    borderLeftStyle: "solid",
    borderTopColor: designTokens.accent[300],
    borderRightColor: designTokens.accent[300],
    borderBottomColor: designTokens.accent[300],
    borderLeftColor: designTokens.accent[300],
    textAlign: "center",
    marginTop: designTokens.spacing[6],
    fontSize: designTokens.fontSize.base,
    lineHeight: "1.6",
    color: designTokens.neutral[700],
    boxSizing: "border-box",
    "@media (min-width: 768px)": {
      paddingTop: designTokens.spacing[6],
      paddingBottom: designTokens.spacing[6],
      paddingLeft: designTokens.spacing[6],
      paddingRight: designTokens.spacing[6],
    },
  },
  contactLink: {
    color: designTokens.accent[500],
    textDecoration: "none",
    ":hover": {
      textDecoration: "underline",
    },
  },
});
